import React from 'react';
import { Link } from 'react-router-dom';
import MainHeading from '../Common/MainHeading';
import { useLocale } from '../../localization/LocaleContext';
import './AudienceSection.css';

const audienceItems = [
    {
        routeKey: 'contractors',
        key: 'contractors',
        icon: (
            <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"/>
            </svg>
        ),
    },
    {
        routeKey: 'freelancers',
        key: 'freelancers',
        icon: (
            <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <rect x="2" y="4" width="20" height="16" rx="2"/>
                <path d="M2 8h20"/>
                <path d="M6 4v0"/>
                <path d="M18 4v0"/>
            </svg>
        ),
    },
    {
        routeKey: 'smallBusiness',
        key: 'smallBusiness',
        icon: (
            <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M3 21h18"/>
                <path d="M5 21V7l7-4 7 4v14"/>
                <path d="M9 21v-6h6v6"/>
            </svg>
        ),
    },
    {
        routeKey: 'organization',
        key: 'organization',
        icon: (
            <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
                <circle cx="9" cy="7" r="4"/>
                <path d="M23 21v-2a4 4 0 0 0-3-3.87"/>
                <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
            </svg>
        ),
    },
];

export default function AudienceSection() {
    const { t, toLocalizedPath } = useLocale();

    return (
        <section className="audience-section sp-90">
            <div className="container">
                <MainHeading headingName={t('homeAudience.heading')} />
                <p className="paragraph p-adjustment text-center m-center audience-subheading">
                    {t('homeAudience.subheading')}
                </p>

                <div className="audience-grid spt-60">
                    {audienceItems.map((item) => (
                        <div className="audience-card" key={item.routeKey}>
                            <div className="audience-icon">{item.icon}</div>
                            <h3 className="h-5 bold-500 audience-title">{t(`homeAudience.${item.key}.title`)}</h3>
                            <p className="paragraph p-adjustment mb-20">{t(`homeAudience.${item.key}.description`)}</p>
                            <Link to={toLocalizedPath(item.routeKey)} className="audience-link">
                                {t(`homeAudience.${item.key}.cta`)}
                                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                    <line x1="5" y1="12" x2="19" y2="12"/>
                                    <polyline points="12 5 19 12 12 19"/>
                                </svg>
                            </Link>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
